import React, {useState} from 'react';
import FileUploadModal from 'components/UploadFiles/FileUploadModal';
import {ReactComponent as AddIcon} from 'assets/svgs/categories/add.svg';
import {ReactComponent as DeleteIcon} from 'assets/svgs/categories/delete.svg';

export default React.memo(({item, handleChange}) => {
  const [selectLogo, setSelectLogo] = useState('');
  const removeAvatar = (event) => {
    event.stopPropagation();
    handleChange('avatar', null);
    handleChange('logoId', null);
  };
  const onSelectFile = (file) => {
    handleChange('logoId', file._id);
    handleChange('avatar', file.liveURL);
    setTimeout(() => {
      setSelectLogo(false);
    });
  };
  return (
    <>
      <div
        className="image-container d-flex align-items-center justify-content-center bg-white mr-3 ml-3 pointer position-relative border-gray"
        onClick={() => setSelectLogo(true)}
      >
        {item.avatar && (
          <div className="delete-avatar-container position-absolute">
            <button
              type="button"
              onClick={removeAvatar}
              className="btn-link position-absolute"
            >
              <DeleteIcon />
            </button>
          </div>
        )}
        <div className="add-cat-row">
          {item.avatar ? (
            <img
              src={item.avatar}
              alt={item.firstName}
              className="avatar-image"
            />
          ) : (
            <button type="button" className="btn-link">
              <AddIcon />
              <div className="text-center mt-2 add-avatar-text">Avatar</div>
            </button>
          )}
        </div>
        {selectLogo && (
          <FileUploadModal
            type="users"
            typeKey="users"
            onSelect={onSelectFile}
            onClose={() => {
              setSelectLogo(false);
            }}
          />
        )}
      </div>
    </>
  );
});
